export const setResponseMessage = (operationType?: string): string => {
  let response = ""
  switch (operationType) {
    case "DeleteDuType":
      response = "Container Type deleted successfully."
      break;

    case "EditDuType":
      response = "Container Type updated successfully."
      break;

    case "CreateDuType":
      response = "Container Type created successfully."
      break;
    case "DeleteFamilyGroup":
      response = "Family Group deleted successfully."
      break;

    case "EditFamilyGroup":
      response = "Family Group updated sucessfully, Updates will reflect after 5 minutes."
      break;

    case "CreateFamilyGroup":
      response = "Family Group created successfully."
      break;

    default:
      response = "Unable to perform operation."
      break;
  }
  return response
}